import useOptions from 'components/Options/OptionsContext/useOptions';
import useApi from '../../api/useApi';
import { useError } from '../../hooks/useError';

const usePaymentProfilesApi = () => {
  const { api } = useApi();
  const { enqueueErrorSnackbar } = useError();
  const { refetchOptions } = useOptions();

  const getPaymentProfiles = async () => {
    try {
      const { data } = await api({
        url: '/settings/payment-profiles/',
        method: 'get'
      });
      return data;
    } catch (error) {
      enqueueErrorSnackbar(error);
    }
  };

  const createPaymentProfile = async (fields) => {
    try {
      const { data } = await api({
        url: '/settings/payment-profiles',
        method: 'post',
        data: fields
      });
      refetchOptions();
      return data;
    } catch (error) {
      enqueueErrorSnackbar(error);
    }
  };

  const updatePaymentProfile = async (id, fields) => {
    try {
      const { data } = await api({
        url: `/settings/payment-profiles/${id}`,
        method: 'put',
        data: fields
      });
      refetchOptions();
      return data;
    } catch (error) {
      enqueueErrorSnackbar(error);
    }
  };

  const deletePaymentProfile = async (id) => {
    try {
      const { data } = await api({
        url: `/settings/payment-profiles/${id}`,
        method: 'delete'
      });
      refetchOptions();
      return data;
    } catch (error) {
      enqueueErrorSnackbar(error);
    }
  };

  return { getPaymentProfiles, createPaymentProfile, updatePaymentProfile, deletePaymentProfile };
};

export default usePaymentProfilesApi;
